import { db } from '../config/firebase';
import { collection, getDocs, addDoc, updateDoc, doc, deleteDoc } from 'firebase/firestore';

export const fetchCustomers = async () => {
  const customersSnapshot = await getDocs(collection(db, 'clients'));
  return customersSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
};

export const createCustomer = async (customer) => {
  const docRef = await addDoc(collection(db, 'clients'), customer);
  return docRef.id;
};

export const updateCustomer = async (id, customer) => {
  await updateDoc(doc(db, 'clients', id), customer);
};

export const deleteCustomer = async (customerId) => {
  try {
    await deleteDoc(doc(db, 'clients', customerId));
  } catch (error) {
    console.error('Error deleting document: ', error);
  }
};
